const PREFIX_KEY = '__KEY_';

export const KEY_LANGUAGE = '_language';
export const SIGN_UP_OTP_CHECKER = 'signUpOtpChecker';

export const KEY_USER_ID = `${PREFIX_KEY}USER_ID`;
export const KEY_AUTH_TOKEN = `${PREFIX_KEY}AUTH_TOKEN`;
export const KEY_REFRESH_TOKEN = `${PREFIX_KEY}REFRESH_TOKEN`;
export const KEY_FORENSICS_ACCESS_TOKEN = `${PREFIX_KEY}FORENSICS_ACCESS_TOKEN`;
export const KEY_IS_SETU_ACCOUNT_SKIPPED = `${PREFIX_KEY}IS_SETU_ACCOUNT_SKIPPED`;
export const KEY_FORENSICS_TRANSACTION_ID = `${PREFIX_KEY}FORENSICS_TRANSACTION_ID`;
export const KEY_FORENSICS_SELFIE_UPLOADED = `${PREFIX_KEY}FORENSICS_SELFIE_UPLOADED`;

export const KEY_SAVE_INIT_VALUE_FORM = `${PREFIX_KEY}SAVE_INIT_VALUE_FORM`;

export const KEY_PHONE_LOGIN = `${PREFIX_KEY}PHONE_LOGIN`;

export const KEY_DEVELOP_MODE = `${PREFIX_KEY}DEVELOP_MODE`;

export const KEY_AMOUNT_APPLICATION = 'loan_sum';
export const KEY_TERM_APPLICATION = 'loan_term';
export const KEY_LOAN_PROMOCODE = 'loan_promocode';
export const KEY_LOAN_PURPOSE = 'loan_purpose';

export const TARGET_URL = 'target_url';
export const TARGET_URL_WRITE = 'target_url_write';

export const KEY_ZOOP_COUNTER = `${PREFIX_KEY}_ZOOP_COUNTER`;
export const KEY_SEON_FINGERPRINT = 'seon_fingerprint';

export const KEY_IS_USER_REGISTERED = `${PREFIX_KEY}_IS_USER_REGISTERED`;
export const KEY_IS_GO_TO_EXPERIAN = `${PREFIX_KEY}IS_GO_TO_EXPERIAN`;
export const KEY_IS_EXPERIAN_REQUEST_EXIST = `${PREFIX_KEY}IS_EXPERIAN_REQUEST_EXIST`;
export const KEY_RETRY_AFTER = `retry_after`;
export const KEY_IS_RETRY_AFTER_EXIST = `is_retry_after_exist`;
export const KEY_IS_COUNTDOWN_WORKING = `is_countdown_working`;
export const KEY_IS_SETU_SHARING_SUCCESS = `${PREFIX_KEY}IS_SETU_SHARING_SUCCESS`;
export const KEY_IS_SETU_SHARING_ABORT = `${PREFIX_KEY}IS_SETU_SHARING_ABORT`;
export const KEY_SETU_CONSENT_ID = `${PREFIX_KEY}SETU_CONSENT_ID`;
export const KEY_AMOUNT_IN_URL = `${PREFIX_KEY}AMOUNT_IN_URL`;
